module.exports = __webpack_public_path__ + "static/media/product-description-row-bg.0a8c7d36.png";